import React, { Component } from 'react';

import moment from 'moment';
import { Form, Row, Col, Input, Button, Modal, Select, DatePicker, message, AutoComplete, Upload, Icon } from 'antd';
import { Message } from 'semantic-ui-react'

import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import { RESTRICTION_TYPE_MAP } from '../../../../../utils/RestrictionTypeUtil';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
};

// Restriction Type
const RestrictionTypeOptions = [];
for (let i = 0; i < RESTRICTION_TYPE_MAP.length; i++) {
  RestrictionTypeOptions.push(<Option key={RESTRICTION_TYPE_MAP[i].code}>{RESTRICTION_TYPE_MAP[i].label}</Option>);
}


class RestrictedSecurityRequestEditDialog extends Component {
  state = {
    
  };

  reloadRestrictedSecurityRequest = () => {
    const {
      employee,
      validDateStart,
      validDateEnd,
    } = this.props.restrictedSecurityQueryParams;
    this.props.loadSubmittedRestrictedSecurityRequest({employee, validDateStart, validDateEnd});
  }

  componentDidMount() {
    this.props.loadRestrictedRuleList({});
  }

  componentDidUpdate() {
    const { 
      updateRestrictedSecurityRequestActionStatus,
      addRestrictedSecurityRequestActionStatus,
    } = this.props;

    // 更新 Restricted Security Request 成功
    if (updateRestrictedSecurityRequestActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Restricted security application are updated successfully!');
      this.reloadRestrictedSecurityRequest();
      this.props.initUpdateRestrictedSecurityRequestActionStatus();
      this.props.resetRestrictedSecurityRequestEditModalDialog();
    } 
    // 更新 Restricted Security Request 失败
    if (updateRestrictedSecurityRequestActionStatus === ACTION_STATUS.ERROR) {
      message.error('Restricted security application are updated failed!');
      this.props.initUpdateRestrictedSecurityRequestActionStatus();
    }

    // add success
    if (addRestrictedSecurityRequestActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Restricted security application are added successfully!');
      this.reloadRestrictedSecurityRequest();
      this.props.initAddRestrictedSecurityRequestActionStatus();
      this.props.resetRestrictedSecurityRequestEditModalDialog();
    }
    if (addRestrictedSecurityRequestActionStatus === ACTION_STATUS.ERROR) {
      message.error('Restricted security application are added failed!');
      this.props.initAddRestrictedSecurityRequestActionStatus();
    }
    // add fail
  }

  onInputChange = ({name, value}) => {
    this.props.restrictedSecurityRequestEditChangeInput({name, value});
  }

  bbgTickerOnChange = (value) => {
    if (!!!value) {
      this.props.clearRestrictedSecurityBbgTickers();
    }

    this.props.restrictedSecurityRequestEditChangeInput({ name: 'bbgTicker', value });
    this.props.form.resetFields();
    this.props.restrictedSecurityRequestBbgTickerSelectChanged(value);
  }


  lastTimeoutID = null;
  bbgTickerOnSearch = (value) => {
    if (!!!value) {
      this.props.clearRestrictedSecurityBbgTickers();
      return;
    }
    this.props.restrictedSecurityRequestEditChangeInput({ name: 'bbgTicker', value });
    if(value.length < 2) {
      return;
    }
    // 输入完毕等待0.5秒后再查询
    // 无此控制会有以下bug：
    // 当输入 2007 时，会分别根据 20、200、2007进行查询
    // 根据2007的查询结果数据量少，最先返回
    // 根据20的查询结果数据量大，最后返回
    // 因此最终展示的，反而是根据20的查询结果，尽管输入的是2007
    if(!!this.lastTimeoutID) {
      clearTimeout(this.lastTimeoutID);
    }
    this.lastTimeoutID = setTimeout(() => {
      this.props.loadRestrictedSecurityRequestBbgTickers(value);
    }, 500);
  }

  
  fundCodeOnChange = (value) => {
    this.props.restrictedSecurityRequestEditChangeInput({ name: 'fund', value });

    if (!!value) {
      this.props.restrictedSecurityRequestFundCodeSelectChanged(value);
    }
  }

  bookCodeOnChange = (value) => {
    this.props.restrictedSecurityRequestEditChangeInput({ name: 'book', value });

    if (!!value) {
      this.props.restrictedSecurityRequestBookCodeSelectChanged(value);
    }
  }

  ruleCodeOnChange = (value) => {
    this.props.restrictedSecurityRequestEditChangeInput({ name: 'ruleCode', value });
  }

  // 提交数据
  submitButtonOnClicked = () => {
    const {
      restrictedSecurityRequestEditControlModal,
    } = this.props;

    const {
      isAddMode,
    } = restrictedSecurityRequestEditControlModal;

    const {
      guid,
      restrictedSecGuid,
      restrictionType,
      fund,
      book,
      personInCharge,
      securityId,
      bbgTicker,
      secName,
      validFrom,
      validTo,
      onListReason,
      offListReason,
      relatedCompany,
      attachment,
      attachmentOriginName,
      requestBy,
      comments,
      fileList,
      ruleCode,
    } = restrictedSecurityRequestEditControlModal.fields;

    const form = this.props.form;

    let source = "Admin";
    let needOnList = true;

    // 表单校验
    form.validateFields((err) => {
        if (!err) {
          if (validTo === '') {
            validTo = '9999-12-31';
          }

          if(isAddMode) {
            let needSendEmail = false;
            this.props.addRestrictedSecurityRequest({
              guid,
              restrictedSecGuid,
              restrictionType,
              fund,
              book,
              personInCharge,
              securityId,
              bbgTicker,
              secName,
              validFrom,
              validTo,
              onListReason,
              offListReason,
              relatedCompany,
              attachment,
              attachmentOriginName,
              requestBy,
              comments,
              fileList,
              needOnList,
              source,
              needSendEmail,
              ruleCode,
            });
          } else {
            this.props.updateRestrictedSecurityRequest({
              guid,
              restrictedSecGuid,
              restrictionType,
              fund,
              book,
              personInCharge,
              securityId,
              bbgTicker,
              secName,
              validFrom,
              validTo,
              onListReason,
              offListReason,
              relatedCompany,
              attachment,
              attachmentOriginName,
              requestBy,
              comments,
              fileList,
              source,
              ruleCode,
            });
          }

        }
      },
    );
  }

  // 附件上传
  attachmentHandleChange = (info) => {
    let fileList = [...info.fileList]; 
    fileList = fileList.slice(-1);

    let fail = false;
    fileList.forEach(file => {
      if (file.response) {
        if(file.response.respCode !== 'S0001') {
          let err = file.response.respMessage;
          message.error(err);
          fail = true;
          return;
        }
        const filename = file.response.data.fileNameWithTimeStamp;
        const originalFileName = file.response.data.originalFileName;
        this.props.restrictedSecurityRequestEditChangeInput({name: 'attachment', value: filename});
        this.props.restrictedSecurityRequestEditChangeInput({name: 'attachmentOriginName', value: originalFileName});
      }
    });

    let newFileList = fail ? [] : fileList;
    this.props.restrictedSecurityRequestEditChangeInput({name: 'fileList', value: newFileList});

  }

  render() {
    const {
      restrictedSecurityRequestEditControlModal,
      fundCodeOptions,
      bookCodeOptions,
      bbgTickerOptions,
      bbgTickerArray,
      userAccountOptions,
      loadRestrictedSecurityBbgTickersActionStatus,
      restrictedSecAttachmentUploadUrl,
      restrictedRuleList,
    } = this.props;


    const {
      isOpened,
      respErrMsg,
      isAddMode,
    } = restrictedSecurityRequestEditControlModal;

    const { getFieldDecorator } = this.props.form;

    let {
      guid,
      restrictedSecGuid,
      restrictionType,
      fund,
      book,
      personInCharge,
      securityId,
      bbgTicker,
      secName,
      validFrom,
      validTo,
      onListReason,
      offListReason,
      relatedCompany,
      attachment,
      attachmentOriginName,
      requestBy,
      comments,
      fileList,
      ruleCode,
    } = restrictedSecurityRequestEditControlModal.fields;

    const {
      updateRestrictedSecurityRequestActionStatus,
      addRestrictedSecurityRequestActionStatus
    } = this.props;

    let action = isAddMode ? "Add" : "Edit";
    let modalTitle = action + " Restricted Security Application";

    const isLoading = updateRestrictedSecurityRequestActionStatus === ACTION_STATUS.LOGINING || addRestrictedSecurityRequestActionStatus == ACTION_STATUS.LOGINING; 

    const bbgTickersSelectIsLoading = loadRestrictedSecurityBbgTickersActionStatus === ACTION_STATUS.LOGINING;

    return (
      <div>
        <Modal
          title={modalTitle}
          centered
          width={1000}
          visible={isOpened}
          confirmLoading={isLoading}
          onOk={this.submitButtonOnClicked}
          onCancel={() => this.props.resetRestrictedSecurityRequestEditModalDialog()}
          destroyOnClose={true}
          maskClosable={false}
          okText="Submit"
          cancelText="Cancel"
        >
          <Form layout="horizontal">
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Restriction Type">
                  {getFieldDecorator('restrictionType', {
                      initialValue: restrictionType,
                      rules: [{
                        required: true,
                        message: 'Please select restriction type',
                      }],
                    })(
                      <Select onChange={(value) => {
                            this.onInputChange({ name: 'restrictionType', value })
                          }} placeholder="Please Choose"
                        >
                        {RestrictionTypeOptions}
                      </Select>
                    )
                  }
                </FormItem>
              </Col>
              {/* <Col span={12}>
                <FormItem {...formItemLayout} label="Fund">
                  {getFieldDecorator('fund', {
                      initialValue: fund,
                      rules: [{
                        required: true,
                        message: 'Please select fund',
                      }],
                    })(
                      <Select 
                        allowClear
                        showSearch
                        onChange={this.fundCodeOnChange} 
                        placeholder="Please Choose"
                        >
                        {fundCodeOptions}
                      </Select>
                    )
                  }
                </FormItem>
              </Col> */}
              <Col span={12}>
                <FormItem {...formItemLayout} label="Rule">
                  {getFieldDecorator('ruleCode', {
                      initialValue: ruleCode,
                      rules: [{
                        required: false,
                        message: 'Please select rule',
                      }],
                    })(
                      <Select 
                        allowClear
                        showSearch
                        onChange={this.ruleCodeOnChange} 
                        placeholder="Please Choose"
                        >
                        {restrictedRuleList.filter(r=>r.isTickerMatched === 1).map(r=><Option key={r.code}>{r.name}</Option>)}
                      </Select>
                    )
                  }
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              {/* <Col span={12}>
                <FormItem {...formItemLayout} label="Book">
                  {getFieldDecorator('book', {
                      initialValue: book,
                      rules: [{
                        required: true,
                        message: 'Please select book',
                      }],
                    })(
                      <Select 
                        allowClear
                        showSearch
                        onChange={this.bookCodeOnChange} 
                        placeholder="Please Choose"
                        >
                        {bookCodeOptions}
                      </Select>
                    )
                  }
                </FormItem>
              </Col> */}
              <Col span={12}>
                <FormItem {...formItemLayout} label="Person In Charge">
                  <Select
                        allowClear
                        showSearch
                        placeholder="personInCharge" 
                        value={personInCharge}
                        onChange={(val) => {
                            this.onInputChange({ name: 'personInCharge', value: val })
                        }} >
                        {userAccountOptions}
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Bbg Ticker">
                  <AutoComplete 
                    allowClear
                    value={bbgTicker}
                    dataSource={bbgTickerArray}
                    onChange={this.bbgTickerOnChange}
                    onSearch={this.bbgTickerOnSearch} />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Sec Name">
                  <Input placeholder="" 
                    value={secName}
                    allowClear
                    onChange={(e) => {
                        this.onInputChange({ name: 'secName', value: e.target.value })
                      }}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Valid From">
                  {getFieldDecorator('validFrom', {
                    initialValue: validFrom === '' ? null : moment(validFrom),
                    rules: [{
                      required: true,
                      message: 'Please select valid from',
                    }],
                  })(
                    <DatePicker 
                      showTime={{ format: 'HH:mm' }}
                      format="YYYY-MM-DD HH:mm"
                      allowClear={false}
                      onChange={(date, dateString) => {
                        this.onInputChange({ name: 'validFrom', value: dateString });
                      }} />
                    )
                  }
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Valid To">
                  <DatePicker 
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY-MM-DD HH:mm"
                    value={moment(validTo)}
                    allowClear={false}
                    onChange={(date, dateString) => {
                      this.onInputChange({ name: 'validTo', value: dateString === '' ? '9999-12-31 00:00' : dateString });
                    }} 
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="On List Reason">
                  {getFieldDecorator('onListReason', {
                      initialValue: onListReason,
                      rules: [{
                        required: true,
                        message: 'Please input on list reason',
                      }],
                    })(
                    <TextArea placeholder="On List Reason" 
                      rows={4}
                      onChange={(e) => {
                          this.onInputChange({ name: 'onListReason', value: e.target.value })
                        }}
                    />
                  )}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Off List Reason">
                  <TextArea placeholder="Off List Reason" 
                    rows={4}
                    value={offListReason}
                    onChange={(e) => {
                        this.onInputChange({ name: 'offListReason', value: e.target.value })
                      }}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Related Company">
                  <TextArea placeholder="Related Company" 
                    value={relatedCompany}
                    rows={4}
                    onChange={(e) => {
                        this.onInputChange({ name: 'relatedCompany', value: e.target.value })
                      }}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Attachment">
                  <Upload
                    name="attachment"
                    withCredentials={true}
                    multiple={true}
                    showUploadList={true}
                    fileList={fileList}
                    action={restrictedSecAttachmentUploadUrl}
                    onChange={this.attachmentHandleChange}
                  >
                    <Button>
                      <Icon type="upload" /> Upload Attachment
                    </Button>
                  </Upload>
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Comments">
                  <TextArea placeholder="Comments" 
                    value={comments}
                    rows={4}
                    onChange={(e) => {
                        this.onInputChange({ name: 'comments', value: e.target.value })
                      }}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                  <p>Maximum Attachment File Size: 10MB<br/>
                  Maximum Attachment File Name Length: 80 English characters or 40 Chinese characters</p>
              </Col>
            </Row>
          </Form>
          {
            !!respErrMsg &&  
            <Message negative>
              <Message.Header>Response Error Message</Message.Header>
            <p>{ respErrMsg }</p>
          </Message>
          }
        </Modal>
      </div>
    );
  }
}

const RestrictedSecurityRequestEditDialogForm = Form.create({ name: 'restricted_list_request_edit_dialog' })(RestrictedSecurityRequestEditDialog);

export default RestrictedSecurityRequestEditDialogForm;